import * as React from 'react';
import * as moment from "moment";
import {HourTimeSelectComponent} from "./HourTimeSelectComponent";
import {OnlineClaimRequest, Policy} from "@falcon/services";
import {Moment} from "moment";
import {getInputClassName} from "../../CommonFunctions";


interface IProps {
    id?: string;
    onlineClaimRequest: OnlineClaimRequest;
    policy: Policy;
    handleAccidentHour: (event: any) => void;
    handleRadioSelection: (event: any) => void;
    setInputValidity: (inputValid: boolean, validationMessage?: string) => void;
    futureDateValidationMessage: string;
    pastDateValidationMessage: string;
    disabled?: boolean;
    inputValid?: boolean;
    validationMessage: string;
}

export class AccidentTimeInput extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);

        this.handleLossHourInput = this.handleLossHourInput.bind(this);
        this.handleHourTimeComponent = this.handleHourTimeComponent.bind(this);
        this.getLossDateValidationResult = this.getLossDateValidationResult.bind(this);
    }

    public render(): React.ReactNode {
        return (
            <div className="form-group mb-0" id={this.props.id ?? ""}>
                <label htmlFor="accidentHour">
                    At what time?
                    <span className="font-weight-light"> (just pick the nearest hour):</span>
                </label>
                <div className="row">
                    <div className="col-3 col-sm-2 mb-3">
                        <div>
                            <input className={`${getInputClassName(this.props.inputValid)}`}
                                id="accident-hour"
                                type="number"
                                value={this.props.onlineClaimRequest.accidentHour}
                                pattern="[0-9]*"
                                max={12}
                                onChange={this.handleLossHourInput}
                                disabled={this.props.disabled ?? false}
                            />
                        </div>
                    </div>
                    <>
                        <div className="col-xs-3 radio-layout-classic">
                            <div className="input-group form-group checkbox-margin-top-20">
                                <HourTimeSelectComponent
                                    accidentHourTime={this.props.onlineClaimRequest.accidentHourTime}
                                    onChange={this.handleHourTimeComponent}
                                    disabled={this.props.disabled ?? false}
                                />
                            </div>
                        </div>
                        {this.props.inputValid === false &&
                            <div className="col-12 mb-3 invalid-feedback d-block">{this.props.validationMessage}</div>
                        }
                    </>
                </div>
            </div>
        )
    }

    private handleLossHourInput(event: any): void {
        const regex = /^(?:[1-9]|1[0-2])$/;
        if (event.target.value === "" || regex.test(event.target.value)) {
            this.props.handleAccidentHour(event);
            this.getLossDateValidationResult();
        }
    }

    private handleHourTimeComponent(event: any): void {
        this.props.handleRadioSelection(event);
        this.getLossDateValidationResult();
    }

    private getLossDateValidationResult(): void {
        const now: Moment = moment();
        const lossDate: Moment = moment(this.props.onlineClaimRequest.accidentDate);
        const policyStartDate: string = new Date(this.props.policy.startDate).toLocaleString("en-GB", {timeZone: "Europe/London"});
        const startDateMoment: Moment = moment(policyStartDate, "DD/MM/YYYY, HH:mm:ss");
        const accidentHourInput: number = parseInt(this.props.onlineClaimRequest.accidentHour, 10);
        const accidentHour: number = accidentHourInput === 12 ? 0 : accidentHourInput;
        let inputValid: boolean;
        let validationMessage: string | undefined;

        if (this.props.onlineClaimRequest.accidentDate && this.props.onlineClaimRequest.accidentHour && this.props.onlineClaimRequest.accidentHourTime) {
            const accident24HourFormat: number = this.props.onlineClaimRequest.accidentHourTime === "AM" ? accidentHour : accidentHour + 12;

            if (lossDate.isAfter(now, 'day') || (lossDate.isSame(now, 'day') && accident24HourFormat > now.hour())) {
                inputValid = false;
                validationMessage = this.props.futureDateValidationMessage;
            } else if (lossDate.isBefore(startDateMoment, 'date') || (lossDate.isSame(startDateMoment, 'date') && accident24HourFormat < moment(startDateMoment).hour())) {
                inputValid = false;
                validationMessage = this.props.pastDateValidationMessage;
            } else {
                inputValid = true;
                validationMessage = undefined;
            }
        } else {
            inputValid = false;
            validationMessage = "Please answer this to carry on";
        }

        this.props.setInputValidity(inputValid, validationMessage);
    }
}
